export const PRODUCT_REFERENCE_COOKIE = 'product-reference'
export const ACCOUNT_SUBSIDIARY_ID_COOKIE = 'subsidiary-id'
export const ACCOUNT_DRAWER_HANDLE = 'accountDrawer'
export const LOGIN_EMAIL_STORAGE_KEY = 'loginEmail'
export const ERP_OPENING_HOURS_CONFIG_STORAGE_KEY = 'erpOpeningHoursConfig'
